import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ParamsService from "../../../Services/Shared/Params.service";
const SearchWithQuery = (props) => {
    const { value, paramLabel = "query", type = "search", title = "Search", placeholder = "search", ariaLabel = "Search", withIcon = true, className, } = props;
    const history = useHistory();
    const location = useLocation();
    const searchBox = useRef();
    useEffect(() => {
        if (searchBox.current) {
            searchBox.current.value = value || "";
        }
    }, [value]);
    const search = () => {
        history.replace(`${location.pathname}?` +
            ParamsService.calcNewParams({
                [paramLabel]: (searchBox.current && searchBox.current.value) || "",
            }));
    };
    console.log("RENDERING SEARCH WITH QUERY");
    return (_jsxs("div", { className: `input-group ${className || ""}`, children: [_jsx("input", { className: "form-control", type: type, title: title, 
                // @ts-expect-error - TS2322 - Type 'MutableRefObject<HTMLInputElement | null | undefined>' is not assignable to type 'LegacyRef<HTMLInputElement> | undefined'.
                ref: searchBox, placeholder: placeholder, "aria-label": ariaLabel, "data-enter-key-press": "search()", onKeyDown: (event) => {
                    if (event.keyCode === 13) {
                        search();
                    }
                } }), withIcon && (_jsx("div", { className: "input-group-append input-group-append-blend", children: _jsxs("button", { className: "btn btn-outline-secondary ", onClick: () => search(), children: [_jsx("span", { className: "fal fa-search", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: "Search" })] }) }))] }));
};
export default SearchWithQuery;
